import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import formatNumber from '../../utilities/Format';
import Odometer from 'react-odometerjs';

import '../../css/odom.css';
class PositionPanel extends Component {
    render() {
        const user = this.props.user;

        return (
            <div className="positions">
                <p style={{ margin: 0, color: 'white', opacity: 0.5 }} >Statistics</p>
                <h4>Available Cash: <span className="portfolioValue">${ (user) ? <Odometer value={user[0].assets} format="(,ddd).dd" /> : 'Loading...' }</span></h4>
                <h5><b>Portfolio Value: </b>${ formatNumber(this.props.portfolioValue.toFixed(2)) }</h5>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        user: state.firestore.ordered.users,
        tradebook: state.firestore.ordered.tradebook,
    };
};

export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => [
        {
            collection: 'trading-book',
            doc: props.auth.uid,
            storeAs: 'tradebook',
        },
        { collection: 'users', doc: props.auth.uid }
    ]),
)(PositionPanel);